import {
  EDIT_KEG_COLLECTION_REQUEST_,
  EDIT_KEG_COLLECTION_REQUEST_SUCCESS,
  EDIT_KEG_COLLECTION_REQUEST_FAILURE,
  EDIT_KEG_COLLECTION_REQUEST_CLEAR,
  EDIT_KEG_COLLECTION_REQUEST_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  EDIT_KEG_COLLECTION_REQUEST_,
  EDIT_KEG_COLLECTION_REQUEST_SUCCESS,
  EDIT_KEG_COLLECTION_REQUEST_FAILURE,
  EDIT_KEG_COLLECTION_REQUEST_CLEAR,
  EDIT_KEG_COLLECTION_REQUEST_QUEUE
)
